import QuickActions from '../components/dashboard/QuickActions'
import PreferencesSummaryCard from '../components/dashboard/PreferencesSummaryCard'
import DateTypeSelector from '../components/dashboard/DateTypeSelector'
import FeelingLuckyPanel from '../components/dashboard/FeelingLuckyPanel'
import CreatePlanPanel from '../components/dashboard/CreatePlanPanel'
import PartnerManagement from '../components/dashboard/PartnerManagement'

export default function Dashboard() {
	return (
		<section className="max-w-6xl mx-auto px-4">
			<h1 className="text-2xl font-semibold text-black">Dashboard</h1>
			<div className="mt-4">
				<h2 className="sr-only">Quick Actions</h2>
				<QuickActions />
			</div>
			<div className="mt-6">
				<FeelingLuckyPanel />
			</div>
			<div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
				<PreferencesSummaryCard />
				<DateTypeSelector />
			</div>
			<div className="mt-6 grid grid-cols-1 gap-4">
				<CreatePlanPanel />
			</div>
			<div className="mt-6">
				<PartnerManagement />
			</div>
		</section>
	)
}
